import React from "react";
import styled from "styled-components";

export default function HandoutFocusBackgroundPicker({ value = "frame", onChange }) {
  return <Picker role="group" aria-label="觀念底樣式">
    {[['gray', '灰底'], ['frame', '框線']].map(([key, label]) => <button key={key} type="button"
      aria-pressed={value === key} onClick={() => onChange(key)}>
      <span className={`sample ${key}`} aria-hidden="true"><i /><i /><i /></span>
      <strong>{label}</strong>
    </button>)}
    <small>高度依文字、公式與圖片自動延伸，不用另外拉高區塊。</small>
  </Picker>;
}

const Picker = styled.div`
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin: 12px 0;
  button { min-width: 0; padding: 10px; border: 1px solid #cbd5e1; border-radius: 8px; background: #fff; color: #1f2937; cursor: pointer; }
  button[aria-pressed=true] { border: 2px solid #2563eb; padding: 9px; background: #eff6ff; }
  .sample { position: relative; display: flex; flex-direction: column; gap: 6px; height: 48px; padding: 10px; box-sizing: border-box; margin-bottom: 7px; }
  .gray { background: #d4d4d4; clip-path: polygon(9px 0,100% 0,100% 100%,0 100%,0 9px); }
  .frame { border: 3px double #696b70; background: #fff; }
  i { display: block; height: 3px; width: 75%; background: #9ca3af; }
  i:last-child { width: 50%; }
  small { grid-column: 1 / -1; color: #64748b; line-height: 1.4; }
`;
